// Minimal XMP builder (Dublin Core + pdfaid for PDF/A-1b scaffolding)
export function buildMinimalXmp(opts: { title?: string; creator?: string; createdAt?: Date; pdfa?: boolean }): Uint8Array {
  const created = (opts.createdAt || new Date()).toISOString();
  const xml = `<?xml version="1.0" encoding="UTF-8"?>\n`+
  `<x:xmpmeta xmlns:x="adobe:ns:meta/" x:xmptk="EdgeDocs XMP 1.0">`+
  `<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xmp="http://ns.adobe.com/xap/1.0/" xmlns:pdfaid="http://www.aiim.org/pdfa/ns/id/">`+
  `<rdf:Description rdf:about="">`+
  `<dc:title><rdf:Alt><rdf:li xml:lang="x-default">${escapeXml(opts.title || 'EdgeDocs PDF')}</rdf:li></rdf:Alt></dc:title>`+
  `<xmp:CreatorTool>${escapeXml(opts.creator || 'EdgeDocs')}</xmp:CreatorTool>`+
  `<xmp:CreateDate>${created}</xmp:CreateDate>`+
  `${opts.pdfa ? '<pdfaid:part>1</pdfaid:part><pdfaid:conformance>B</pdfaid:conformance>' : ''}`+
  `</rdf:Description>`+
  `</rdf:RDF></x:xmpmeta>`;
  return new TextEncoder().encode(xml);
}

function escapeXml(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}







